import i18n from '../../utils/i18n.js';

class BceContentLimiter {
	constructor() {
		this.instances = new WeakMap();
		this.autoInit = false;
	}

	init(selector = '.bce_content-limiter') {
		const containers = document.querySelectorAll(selector);
		containers.forEach((el) => {
			if (!this.instances.has(el)) {
				this.create(el);
			}
		});
	}

	create(element) {
		if (this.instances.has(element)) {
			return this.instances.get(element);
		}

		// Extract height from class name (e.g., bce_content-limiter-400 -> 400)
		const heightMatch = element.className.match(/bce_content-limiter-(\d+)/);
		const maxHeight = heightMatch ? parseInt(heightMatch[1], 10) : 400;

		// Set CSS custom property for this element
		element.style.setProperty('--limiter-max-height', `${maxHeight}px`);

		// Add expanded class structure if not already present
		if (!element.classList.contains('bce_content-limiter--initialized')) {
			element.classList.add('bce_content-limiter--initialized');

			// Create toggle button
			const toggleBtn = document.createElement('button');
			toggleBtn.className = 'bce_content-limiter__toggle';
			toggleBtn.textContent = i18n.t('contentLimiter', 'showMore');
			toggleBtn.setAttribute('type', 'button');
			toggleBtn.setAttribute('aria-expanded', 'false');

			// Insert button after content
			element.parentNode.insertBefore(toggleBtn, element.nextSibling);

			// Toggle functionality
			toggleBtn.addEventListener('click', () => {
				const isExpanded = element.classList.contains('bce_content-limiter--expanded');

				if (isExpanded) {
					element.classList.remove('bce_content-limiter--expanded');
					toggleBtn.textContent = i18n.t('contentLimiter', 'showMore');
					toggleBtn.setAttribute('aria-expanded', 'false');

					// Scroll back to top of element
					element.scrollIntoView({ behavior: 'smooth', block: 'start' });
				} else {
					element.classList.add('bce_content-limiter--expanded');
					toggleBtn.textContent = i18n.t('contentLimiter', 'showLess');
					toggleBtn.setAttribute('aria-expanded', 'true');
				}
			});

			const instance = {
				element,
				toggleBtn,
				destroy: () => {
					toggleBtn.remove();
					element.classList.remove('bce_content-limiter--initialized', 'bce_content-limiter--expanded');
					element.style.removeProperty('--limiter-max-height');
					this.instances.delete(element);
				}
			};

			this.instances.set(element, instance);
			return instance;
		}

		return null;
	}

	getInstance(element) {
		return this.instances.get(element) || null;
	}
}

export default new BceContentLimiter();
